export default "__VITE_ASSET__20f97e19__"